import { defineStore } from 'pinia'


export const MENU_KEY = "web-menu";
export const PERSON_MENU_KEY = "web-menu-person";
export const PERMISSIONS_KEY = "web-permissions";

interface MENU {
  menu: any[]
  personMenu: any[]
  permissions: any[]
}

export const useMenuStore = defineStore('menu', {
  state: (): MENU => ({
    menu: [],
    personMenu: [],
    permissions: []
  }),
  actions: {
    getMenu() {
      const menu = window.localStorage.getItem(MENU_KEY)
      const permissions = window.localStorage.getItem(PERMISSIONS_KEY)
      if (menu && permissions) {
        try {
          this.menu = JSON.parse(menu) as any[];
          this.permissions = JSON.parse(permissions) as any[];
        } catch (_e) { }
      }
    },
    getPersonMenu() {
      const menu: any = window.localStorage.getItem(PERSON_MENU_KEY)
      const permissions = window.localStorage.getItem(PERMISSIONS_KEY)
      if (menu && permissions) {
        try {
          this.personMenu = JSON.parse(menu) as any[];
          this.permissions = JSON.parse(permissions) as any[];
        } catch (_e) { }
      }
    },
    setPersonMenu(menu: any, permissions:any) {
      if (menu) {
        window.localStorage.setItem(PERSON_MENU_KEY, JSON.stringify(menu))
      }
      this.setMenu(undefined, permissions)
    },
    setMenu(menus: any, permissions: any) {
      let oldPermissions:any = window.localStorage.getItem(PERMISSIONS_KEY);
      if (oldPermissions) {
        try {
          oldPermissions = JSON.parse(oldPermissions) as any[];
          permissions = permissions.concat(oldPermissions);
        } catch (_e) { }
      }

      if (menus) {
        window.localStorage.setItem(MENU_KEY, JSON.stringify(menus))
      }
      if (permissions) {
        window.localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
      }
    }
  }
})